// import { Box, Button, Divider, Grid, Card, CardContent, List, ListItem, ListItemText } from "@mui/material";
// import Typography from "@mui/material/Typography";
// import { useTranslation } from 'react-i18next';
// import { motion } from "framer-motion"
// import image1 from "../../../public/main/Rastcom - forBusiness.png"
// import image2 from "../../../public/main/forBusiness2.png"

// function ForBusiness() {
//     const { t, i18n } = useTranslation();
//     const text = t("forBusiness.subTitle").split("");

//     return (
//         <>
//             <Grid container pt={5}
//                 sx={{
//                     display: 'flex',
//                     msFlexDirection: 'row',
//                     justifyContent: 'center',
//                     backgroundColor: "#F9FAFB",
//                     alignItems: "center",
//                     flexDirection: { xs: 'column', md: "row" },
//                     marginBottom: 0,
//                     padding: { md: '0px 20px' }
//                 }}
//             >
//                 <Box
//                     sx={{
//                         display: 'flex',
//                         flexDirection: 'column',
//                         alignItems: 'center',
//                         textAlign: 'center',
//                     }}
//                 >
//                     <motion.div
//                         initial={{ opacity: 0, y: 20 }}
//                         whileInView={{ opacity: 1, y: 0 }}
//                         transition={{ duration: 0.6 }}
//                         viewport={{ once: true }}
//                     >
//                         <Divider
//                             sx={{
//                                 borderBottomColor: 'linear-gradient(135deg, #3b0764, #9333ea)',
//                                 borderBottomWidth: '2px',
//                                 borderBottomStyle: 'solid'
//                             }}
//                             role="presentation"
//                         >
//                             <Typography
//                                 sx={{
//                                     fontSize: 26,
//                                     fontWeight: 600,
//                                     fontFamily: "Arial, sans-serif",
//                                     padding: "20px",
//                                     color: "#32325d",
//                                 }}
//                             >
//                                 {t("forBusiness.title")}
//                             </Typography>
//                         </Divider>
//                     </motion.div>
//                     <motion.div
//                         initial={{ opacity: 0, scale: 0.8 }}
//                         whileInView={{ opacity: 1, scale: 1 }}
//                         transition={{ duration: 0.4, delay: 0.4 }}
//                         viewport={{ once: true }}
//                     >
//                         <Button
//                             variant="contained"
//                             href={`${i18n.language}/contact-us`}
//                             sx={{
//                                 mt: 2,
//                                 fontFamily: "Arial, sans-serif",
//                                 background: "linear-gradient(135deg, #3b0764, #9333ea)",
//                                 borderRadius: "20px"
//                             }}
//                         >
//                             {t("forBusiness.requestDemo")}
//                         </Button>
//                     </motion.div>

//                 </Box>

//                 <Grid container
//                     sx={{
//                         display: 'flex',
//                         justifyContent: 'center',
//                         backgroundColor: "#F9FAFB",
//                         alignItems: "center",
//                         flexDirection: { xs: 'column-reverse', md: "row" },
//                         marginBottom: 0,
//                     }}
//                 >
//                     <Grid item md={5} sm={11} xs={11} m={2}>
//                         <motion.div
//                             initial={{ opacity: 0, y: 20 }}
//                             whileInView={{ opacity: 1, y: 0 }}
//                             transition={{ duration: 0.6, delay: 0.2 }}
//                             viewport={{ once: true }}
//                         >
//                             <List sx={{ width: "100%" }}>
//                                 <ListItem>
//                                     <ListItemText
//                                         secondaryTypographyProps={{
//                                             textAlign: "center",
//                                             fontSize: "20px",
//                                             fontWeight: "bold",
//                                             color: "#800080",
//                                         }}
//                                         secondary={t("forBusiness.secList1")}
//                                     />
//                                 </ListItem>
//                             </List>
//                         </motion.div>
//                         <motion.div
//                             initial={{ opacity: 0 }}
//                             whileInView={{ opacity: 1, transition: { staggerChildren: 0.2 } }} // Trigger when visible
//                             viewport={{ once: true, amount: 0.2 }} // Only trigger once when 20% is in view
//                         >
//                             <List sx={{ width: "100%", padding: "10px" }}>
//                                 {["uList1", "uList2", "uList3"].map((key, index) => (
//                                     <motion.div
//                                         key={index}
//                                         initial={{ opacity: 0, y: 20 }}
//                                         whileInView={{ opacity: 1, y: 0, transition: { duration: 0.4 } }}
//                                         viewport={{ once: true }} // Ensures it animates only once
//                                         whileHover={{ scale: 1.05 }}
//                                     >
//                                         <ListItem sx={{ borderLeft: "4px solid #9333ea", mb: 1 }}>
//                                             <ListItemText
//                                                 primaryTypographyProps={{
//                                                     fontSize: "16px",
//                                                     fontWeight: "bold",
//                                                     color: "#32325d",
//                                                 }}
//                                                 primary={t(`forBusiness.${key}`)}
//                                             />
//                                         </ListItem>
//                                     </motion.div>
//                                 ))}
//                             </List>
//                         </motion.div>
//                         <List sx={{ width: '100%' }}>
//                             <ListItem >
//                                 <ListItemText secondaryTypographyProps={{ fontSize: '14px', color: '#32325d', }} secondary={t('forBusiness.secList2')} />
//                             </ListItem>
//                         </List>
//                     </Grid>

//                     <Grid item xs={11} md={5} lg={5}
//                         sx={{
//                             width: '80%',
//                             height: 'auto',
//                             alignItems: 'center',
//                             padding: '10px 0 20px 0',
//                             borderRadius: '10px',
//                             margin: 'auto'
//                         }}
//                     >
//                         <motion.div
//                             initial={{
//                                 scale: .7
//                             }}
//                             whileInView={{
//                                 scale: .9
//                             }}
//                             transition={{
//                                 duration: .5
//                             }}
//                             viewport={{ once: true }}
//                         >
//                             <img
//                                 src={image1}
//                                 style={{
//                                     marginTop: "20px",
//                                     maxWidth: "100%",
//                                     minHeight: "auto"
//                                 }}
//                             />
//                         </motion.div>
//                     </Grid>
//                 </Grid>
//             </Grid >
//         </>
//     )
// }

// export default ForBusiness


import { Box, Button, Divider, Grid, List, ListItem, ListItemText } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useTranslation } from 'react-i18next';
import { motion } from "framer-motion";
import image1 from "../../../public/main/Rastcom - forBusiness.png";
import image2 from "../../../public/main/forBusiness2.png";

function ForBusiness() {
    const { t, i18n } = useTranslation();

    return (
        <>
            <Grid
                container
                pt={5}
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    // background: "linear-gradient(135deg, #0f172a, #1e293b)", // dark blue gradient
                    background: "#112240",
                    flexDirection: { xs: 'column', md: "row" },
                    padding: { md: '0px 20px' },
                    color: "#f1f5f9",
                }}
            >
                {/* Left Section */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center',
                    }}
                >
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        viewport={{ once: true }}
                    >
                        <Divider
                            sx={{
                                borderBottom: "2px solid transparent",
                                backgroundImage: "linear-gradient(90deg, #2563eb, #9333ea)",
                                backgroundClip: "text",
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: 28,
                                    fontWeight: 700,
                                    fontFamily: "Inter, sans-serif",
                                    padding: "20px",
                                    color: "#f8fafc",
                                    textShadow: "0px 2px 8px rgba(0,0,0,0.5)",
                                }}
                            >
                                {t("forBusiness.title")}
                            </Typography>
                        </Divider>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, scale: 0.8 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.4, delay: 0.4 }}
                        viewport={{ once: true }}
                    >
                        <Button
                            variant="contained"
                            href={`${i18n.language}/contact-us`}
                            sx={{
                                mt: 3,
                                px: 4,
                                py: 1.5,
                                fontSize: "16px",
                                fontFamily: "Inter, sans-serif",
                                fontWeight: 600,
                                background: "linear-gradient(135deg, #2563eb, #9333ea)",
                                borderRadius: "30px",
                                boxShadow: "0 4px 20px rgba(147, 51, 234, 0.4)",
                                transition: "all 0.3s ease",
                                "&:hover": {
                                    background: "linear-gradient(135deg, #1d4ed8, #7e22ce)",
                                    boxShadow: "0 6px 24px rgba(147, 51, 234, 0.6)",
                                },
                            }}
                        >
                            {t("forBusiness.requestDemo")}
                        </Button>
                    </motion.div>
                </Box>

                {/* Right Section */}
                <Grid
                    container
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: "center",
                        flexDirection: { xs: 'column-reverse', md: "row" },
                        mt: { xs: 5, md: 0 },
                    }}
                >
                    {/* Text Content */}
                    <Grid item md={5} sm={11} xs={11} m={2}>
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.2 }}
                            viewport={{ once: true }}
                        >
                            <List sx={{ width: "100%" }}>
                                <ListItem>
                                    <ListItemText
                                        secondaryTypographyProps={{
                                            textAlign: "center",
                                            fontSize: "22px",
                                            fontWeight: "bold",
                                            color: "#38bdf8",
                                        }}
                                        secondary={t("forBusiness.secList1")}
                                    />
                                </ListItem>
                            </List>
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0 }}
                            whileInView={{ opacity: 1 }}
                            transition={{ staggerChildren: 0.2 }}
                            viewport={{ once: true, amount: 0.2 }}
                        >
                            <List sx={{ width: "100%", padding: "10px" }}>
                                {["uList1", "uList2", "uList3"].map((key, index) => (
                                    <motion.div
                                        key={index}
                                        initial={{ opacity: 0, y: 20 }}
                                        whileInView={{
                                            opacity: 1,
                                            y: 0,
                                            transition: { duration: 0.4 },
                                        }}
                                        viewport={{ once: true }}
                                        whileHover={{ scale: 1.05 }}
                                    >
                                        <ListItem
                                            sx={{
                                                borderLeft: "4px solid #9333ea",
                                                mb: 1,
                                                background: "rgba(255,255,255,0.05)",
                                                borderRadius: "10px",
                                                transition: "all 0.3s ease",
                                                "&:hover": {
                                                    background: "rgba(147, 51, 234, 0.15)",
                                                },
                                            }}
                                        >
                                            <ListItemText
                                                primaryTypographyProps={{
                                                    fontSize: "16px",
                                                    fontWeight: "bold",
                                                    color: "#f1f5f9",
                                                }}
                                                primary={t(`forBusiness.${key}`)}
                                            />
                                        </ListItem>
                                    </motion.div>
                                ))}
                            </List>
                        </motion.div>

                        <List sx={{ width: '100%' }}>
                            <ListItem>
                                <ListItemText
                                    secondaryTypographyProps={{
                                        fontSize: '14px',
                                        color: '#94a3b8',
                                    }}
                                    secondary={t('forBusiness.secList2')}
                                />
                            </ListItem>
                        </List>
                    </Grid>

                    {/* Image */}
                    <Grid
                        item
                        xs={11}
                        md={5}
                        lg={5}
                        sx={{
                            width: '80%',
                            height: 'auto',
                            alignItems: 'center',
                            padding: '10px 0 20px 0',
                            margin: 'auto',
                        }}
                    >
                        <motion.div
                            initial={{ scale: 0.7 }}
                            whileInView={{ scale: 0.9 }}
                            transition={{ duration: 0.5 }}
                            viewport={{ once: true }}
                        >
                            <img
                                src={image1}
                                style={{
                                    marginTop: "20px",
                                    maxWidth: "100%",
                                    borderRadius: "16px",
                                    boxShadow: "0 6px 24px rgba(0,0,0,0.5)",
                                }}
                            />
                        </motion.div>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}

export default ForBusiness;
